import React from 'react';

function escapeRegExp(value) {
  return String(value).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

/** Plain text from HTML for in-page find (no tags). */
export function htmlToPlainText(html) {
  if (html == null || html === '') return '';
  return String(html)
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

/**
 * Wrap case-insensitive matches of `query` in <mark> for chat browse search.
 */
export function renderTextWithSearchHighlight(text, query, markClassName = 'team-assistant-search-highlight') {
  const source = text == null ? '' : String(text);
  const term = (query || '').trim();
  if (!source || !term) return source;

  const re = new RegExp(`(${escapeRegExp(term)})`, 'gi');
  const parts = source.split(re);
  if (parts.length <= 1) return source;

  return parts.map((part, index) => {
    if (!part) return null;
    const isMatch = index % 2 === 1;
    if (isMatch) {
      return (
        <mark key={`${index}-${part.slice(0, 12)}`} className={markClassName}>
          {part}
        </mark>
      );
    }
    return <React.Fragment key={`${index}-t`}>{part}</React.Fragment>;
  });
}
